import React from 'react';
import moment from 'moment';
import QRCode from 'qrcode.react';
import { PREFIX_FRONT_URL } from '../../../consts';
import utils from '../../../common/utils';

export default (props) => (
  <>
    <div className="drawer-top drawer-top-info">
      {/* <p className="h5">{window.$t('exchange.exchange_select.my_account')}</p> */}
      <div
        className="d-flex space-between align-items fontW-700 text-normal"
      >
        <div>{props.info.email || props.info.display_name || '...'}</div>
        <div
          onClick={() => {
            props.logout();
            window.$isAuthenticated = false;
            window.h.push(`${PREFIX_FRONT_URL}/home`);
          }}
          className="info-logout"
        >
          <span className="icon-log-out" />
        </div>
      </div>
      <div className="hr" />
      <div className="d-flex align-items text-normal fontW-700">
        <div className="icon-info-left">
          <span className="icon-gender info-icon" />
        </div>
        <div>
          {window.$t('exchange.exchange_select.gender')}
          :
          {' '}
        </div>
        <div style={{ marginLeft: 3 }}>{props.info.status || window.$t('common.empty')}</div>
      </div>

      <div className="d-flex align-items text-normal fontW-700">
        <div className="icon-info-left"><span className="icon-birthday-cake info-icon" /></div>
        <div>
          {window.$t('exchange.exchange_select.date_of_birth')}
          :
          {' '}
        </div>
        <div style={{ marginLeft: 3 }}>{utils.formatTimeFromUnix(props.info.registration_date || moment.now())}</div>
      </div>

      <div className="d-flex align-items text-normal fontW-700">
        <div className="icon-info-left">
          <span className="icon-phone1 info-icon" />
        </div>
        <div>{props.info.phone || window.$t('common.empty')}</div>
      </div>

      <div className="d-flex align-items text-normal fontW-700">
        <div className="icon-info-left"><span style={{ fontSize: 19 }} className="icon-mail1 info-icon" /></div>
        <div>{props.info.email || window.$t('common.empty')}</div>
      </div>

      <div className="d-flex align-items text-normal fontW-700">
        <div className="icon-info-left"><span style={{ paddingLeft: 3 }} className="icon-lock1 info-icon" /></div>
        <div>{window.$t('exchange.exchange_select.lock')}</div>
      </div>

      <div className="info-qr">
        <div className="info-qr-code">
          {props.info.pubkey}
        </div>
        <div className="text-center "><QRCode style={{ border: 'thick white solid', height: '113px', width: '113px' }} value={props.info.pubkey || ''} /></div>
      </div>

    </div>
  </>
);
